module.exports = __webpack_public_path__ + "static/ClimateAI-27bcac79bcc824e9f6a8d790b7dddb94.jpg";